import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadArticles: false,
  isLoadRestau2: false,
  errorRestau1: "",
  articles: [],
  articlesSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadArticles: state => state.isLoadArticles,
  isLoadRestau2: state => state.isLoadRestau2,
  errorRestau1: state => state.errorRestau1,
  articles: state => state.articles,
};

const mutations = {
  getArticlesSuccess(state, payload) {
    state.isLoadArticles = true;
    state.articles = payload.articles;
  },
  addArticleSuccess(state, payload) {
    // console.log({payload});
    // console.log("FROMMUATETTAGSUCCES");
    state.isLoadArticles = true;
    let articles = state.articles;
    articles.push(payload.data);
    state.articles = articles;
  },
  editArticleSuccess(state, payload) {
    console.log("FROM MUTATE");
    console.log(payload);
    state.isLoadArticles = true;
    let articles = state.articles;

    let newArticles = [];
    articles.map((article, index) => {
      if (article._id == payload.data._id) {
        newArticles.push({ ...payload.data });
      } else {
        newArticles.push({ ...article });
      }
    });
    state.articles = [...newArticles];
  },
  deleteArticleSuccess(state, payload) {
    state.isLoadArticles = true;
    let articles = state.articles;

    let newArticles = [];
    articles.map((article, index) => {
      if (article._id != payload.data._id) {
        newArticles.push({ ...article });
      }
    });
    state.articles = [...newArticles];
  },
  addARTSuccess(state, payload) {
    state.isLoadArticles = true;

  },
  getArticlesError(state, error) {
    state.isLoadArticles = false;
    state.errorRestau1 = error;
  },
  addArticleError(state, error) {
    state.isLoadArticles = false;
    state.errorRestau1 = error;
  }
};

const actions = {
  getArticles({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/articles/${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getArticlesSuccess", {
            articles: res.data
          });
        } else {
          commit("getArticlesError", "error:getArticles");
        }
      });
  },
  addArticle({ commit }, payload) {
    return axios
      .post(`${apiPath}/articles`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addArticleSuccess", res);
        } else {
          commit("addArticleError", "error:addArticle");
        }
        return res;
      });
  },
  editArticle({ commit }, payload) {
    console.log("FROM EDIT TAG AXIOS");
    console.log(payload);
    return axios
      .post(`${apiPath}/articles/${payload.id}`, payload.formdata, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editArticleSuccess", res);
        } else {
          commit("addArticleError", "error:addArticle");
        }
        return res;
      });
  },
  // SyncRestau({ commit }, payload,config) {
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  // },

  deleteArticle({ commit }, payload) {
    return axios
      .delete(`${apiPath}/articles/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePosSuccess", payload);
        // } else {
        //   commit("addPosError", "error:addPos");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addARTSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
